module.exports = __webpack_public_path__ + "img/gifpayment.38c93693.gif";